import axios from 'axios'
import router from 'src/router'
import { Loading } from 'quasar'

const api = axios.create({
  baseURL: process.env.API,
  headers: {},
  timeout:false,
  params: {}
})

api.interceptors.request.use(
  response => {
    // Do something before request is sent
    const userToken = window.localStorage.getItem('user-token')
    if (userToken) response.headers['Authorization'] = userToken
    response.headers["Access-Control-Allow-Origin"] = "*"
    response.headers["Pragma"] = "no-cache"
    return response
  }
)

api.interceptors.response.use(async (response) => {
    let publicRoutes = ['/login','/attend','/forgotpassword'],
        isPublicRoute = publicRoutes.includes(window.location.pathname)
    if(!isPublicRoute) Loading.hide()

    return response
  },
  async (error) => {
    let publicRoutes = ['/login','/attend','/forgotpassword'],
        isPublicRoute = publicRoutes.includes(window.location.pathname)

    // If no response, axios throws "Network Error", this is a 401.
    if(!error.response){
      if(!isPublicRoute){
        Loading.show({
          message: 'Awaiting Connection..'
        })
      }
    //   window.localStorage.removeItem('user-token')
    //   api.defaults.headers.common['Authorization'] = null
    //   if(!window.sessionExpiredNotified){
    //     //await api.create
    //     notify.create({ message: "Session Expired. Please Login again.", type: 'negative' })
    //     window.sessionExpiredNotified = true
    //   }
    //   router.push('/login')
    }
  })

export default ({ Vue }) => {
  Vue.prototype.$axios = api
}

export { api }
